import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class UtilsService {

	constructor() { }

	isString(value: unknown): value is string {
		return typeof value === 'string';
	}

	formatCurrency(value: number): string {
		return `$${value.toFixed(2)}`;
	}

	getEmptyValue<T extends string | number | boolean | object | any[]>(value: unknown, type: 'string' | 'number' | 'boolean' | 'object' | 'array'): T {
		if (typeof value === type) {
			return value as T;
		}
		switch (type) {
			case 'string':
				return '' as T; // Empty string
			case 'number':
				return 0 as T; // Zero for numbers
			case 'boolean':
				return false as T; // False for booleans
			case 'object':
				return null as unknown as T; // Null for objects
			case 'array':
				return [] as T; // Empty array
			default:
				throw new Error('Unsupported type');
		}
	}

	getFormattedObject<T extends string | number | boolean | object | any[]>(value: unknown, type: 'string' | 'number' | 'boolean' | 'object' | 'array'): T {
		if (typeof value === type) {
			return value as T;
		}
		switch (type) {
			case 'string':
				return '' as T; // Empty string
			case 'number':
				return 0 as T; // Zero for numbers
			case 'boolean':
				return false as T; // False for booleans
			case 'object':
				return null as unknown as T; // Null for objects
			case 'array':
				return [] as T; // Empty array
			default:
				throw new Error('Unsupported type');
		}
	}
}
